module.exports = __webpack_public_path__ + "static/media/cached-resources.bf6e3a77.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/step-5/cached-resources.png
 ** module id = 355
 ** module chunks = 0
 **/